module.exports = __webpack_public_path__ + "img/hr-water-side.af4d1f99.png";